import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { TableData } from "~/common/components";
import MenuIcon from "~/common/components/icons/MenuIcon";
import { formatDateWithHour } from "~/common/utils";
import { SupplementalQuestion } from "~/providers/types/supplementalQuestions";

interface SortableSupplementalQuestionProps {
  question: SupplementalQuestion;
  order: number;
}

export const SortableSupplementalQuestion = ({
  question,
  order,
}: SortableSupplementalQuestionProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: question.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="text-sm"
    >
      <TableData className="p-0">
        <div className="flex h-full w-24 items-center justify-center gap-2 bg-neutral-100">
          <span>
            <MenuIcon />
          </span>
          <span>{order}</span>
        </div>
      </TableData>
      <TableData className="w-full whitespace-normal first-letter:uppercase">
        {question.text}
      </TableData>
      <TableData className="whitespace-nowrap">
        {formatDateWithHour(question.updated_at)}
      </TableData>
    </tr>
  );
};
